export const UI = {
  find: (selector => document.querySelector(selector)),
  findAll: (selector => document.querySelectorAll(selector)),
  
  showModal:((id)=>{
    var modalOverlay = document.querySelector('.dropdown-overlay');
    var body = document.querySelector('body');
    var modal = document.querySelector(".modal#"+id);
    modalOverlay.classList.remove('out-of-sight');
    body.style.overflow = 'hidden';
    modal.classList.add('show');
  }),

  hideModals:(()=>{
    var modalOverlay = document.querySelector('.dropdown-overlay');
    var body = document.querySelector('body');
    var modals = document.querySelectorAll(".modal");
    modalOverlay.classList.add('out-of-sight');
    body.style.overflow = 'auto';
    for (let i = 0; i < modals.length; i++) {
      var modal = modals[i];
      modal.classList.remove('show');
    }
  }),
}
